export default {
  message: {
    noData: "暂无数据",
  },
  header: {
    home: "首页",
    anchor: "主播",
    schedule: "赛程",
    news: "资讯",
    subscribe: "订阅",
    download: "下载APP",
    apply_anchor: "申请主播",
    login: "登录",
    register: "注册",
    personal_center: "个人中心",
    logout: "退出登录",
  },
  footer: {
    pro_anchor_exclusive: "专业主播·独家赛事",
    global_events: "全球赛事",
    hd_live: "高清直播",
    pro_anchor: "专业主播",
    massive_data: "海量数据",
    user_agreement: "用户协议",
    privacy_policy: "隐私政策",
    disclaimer: "免责声明",
    permission_details: "权限详情",
    ios_download: "IOS下载",
    android_download: "Android下载",
    qr_code: "二维码",
  },
  downloadTip: {
    online_service: "在线客服",
    download: "下载",
    qr_code: "二维码",
    download_app: "下载APP",
    more_live: "更多比赛直播",
    cooperation: "合作",
    no_content: "暂无相关内容，敬请期待！",
  },
  findPassword: {
    title: "找回密码",
    input_phone: "请输入号码",
    input_code: "请输入验证码",
    input_password: "请输入密码",
    code_empty: "验证码不能为空",
    get_code: "获取验证码",
    resend: "重新发送（{second}）",
    get_code_success: "获取验证码成功",
    phone_warn: "请填写正确格式的手机号",
    pass_warn: "密码为6-20位字母数字组合！",
    find_now: "立即找回",
    success: "密码修改成功，请重新登录！",
  },
  register: {
    title: "注册",
    input_phone: "请输入手机号",
    input_code: "请输入验证码",
    input_password: "请输入6-20位字母数字组合的密码",
    code_warn: "请输入格式正确的验证码",
    pass_warn: "请输入6-20位字母数字组合的密码",
    go_login: "去登录",
    register_and_login: "注册并登录",
    get_code: "获取验证码",
    resend: "重新发送（{second}）",
    get_code_success: "验证码发送成功，请注意查收",
    phone_warn: "请填写正确格式的手机号",
    login_success: "登录成功",
  },
  mainTain: {
    img_alt: "图片",
    system_maintain: "系统维护中...",
    maintain_words:
      "为了更好的为您服务，本网站正在升级维护中，因此带来不便深表歉意",
  },
  login: {
    title: "登录",
    input_phone: "请输入号码",
    input_password: "请输入密码",
    register_now: "立即注册",
    forget_password: "忘记密码",
    login_btn: "登录",
    phone_warn: "请填写正确格式的手机号",
    pass_warn: "密码为6-20位字母数字组合！",
    phone_empty: "请填写手机号",
    pass_empty: "请填写密码",
    login_success: "登录成功",
    pass_error: "密码错误！",
  },
  livingRank: {
    gold_anchor: "金牌主播",
    anchor_recommend: "主播推荐",
    change_batch: "换一批",
    subscribe: "订阅",
    subscribed: "已订阅",
  },
  introduceLive: {
    live_recommend: "直播推荐",
    recommend: "推荐",
    足球: "足球",
    篮球: "篮球",
    电竞: "电竞",
    网球: "网球",
    排球: "排球",
    乒乓球: "乒乓球",
    羽毛球: "羽毛球",
    板球: "板球",
    搏击: "搏击",
    其他: "其他",
    icon_alt: "图标",
  },
  tipBox: {
    success: "操作成功",
    login_success: "登录成功",
  },
  video: {
    enterStudio: "进入直播间",
    danmu: "弹幕",
    loading: "正在加载中...",
    download_app: "下载APP",
    more_live: "更多比赛直播",
    more_video: "更多比赛视频",
    link_failed: "链接失败，请重新加载",
    reload: "重新加载",
    danmu: "弹幕",
    enter_live: "进入直播间",
    drag_tip: "按住视频可进行拖动",
    click_pause: "点击暂停",
    click_play: "点击播放",
    click_mute: "点击静音",
    cancel_mute: "取消静音",
    click_fullscreen: "点击全屏",
    exit_fullscreen: "退出全屏",
    load_error: "加载错误",
  },
  home: {
    announcement: "公告",
    match_recommend: "赛事推荐",
    icon_alt: "图标",
    living: "直播中",
    book_now: "立即预约",
    ended: "已结束",
    match_ended: "比赛已结束！",
    coming_soon: "敬请期待！",
    not_started: "未开赛",
    delayed: "已延期",
    deleted: "已删除",
  },
  myLiving: {
    my_live: "我的直播",
    subscribe: "订阅",
    exit_live: "退出直播",
    tips: "温馨提示",
    obs_tip: "OBS或其他第三方直播软件进行直播，推流成功后点击开始直播",
    push_url: "推流地址",
    stream_name: "流名",
    copy: "点击复制",
    start_live: "开始直播",
    live_notice: "直播公告",
    contact_us: "联系我们",
    copy_success: "复制成功快去联系主播吧！",
    copy_address_success: "复制地址成功",
    edit_notice_tip: "开启直播后才可以修改直播信息",
  },
  advisory: {
    related: "相关文章",
    recommend: "推荐资讯",
    more: "更多",
  },
  competition: {
    nav_0: "热门赛程",
    nav_1: "全部赛程",
    nav_2: "我的预约",
    all_matches: "全部赛事",
    kill: "击杀",
    economy: "经济",
    tower: "推塔",
    dragon: "小龙",
    odds: "指数",
    analysis: "分析",
    ended: "已结束",
    not_started: "未开始",
    delayed: "已延期",
    deleted: "已删除",
    match_num: "第{num}场",
    week: "星期",
    today: "今日",
    loading: "更多数据正在加载中...",
    no_more_data: "没有更多数据了",
  },
  download: {
    scan_tip: "扫一扫下载体育直播APP",
    ios_download: "IOS下载",
    android_download: "Android下载",
    android_download2: "安卓下载",
    ios_guide: "查看ios安装教程",
    global_matches: "全球赛事",
    hd_live: "高清直播",
    pro_live: "专业直播",
    mass_data: "海量数据",
  },
  giftItem: {
    send_gift: "送出{gift}",
  },
  live: {
    recommend: "推荐",
    推荐: "推荐",
    足球: "足球",
    篮球: "篮球",
    电竞: "电竞",
    网球: "网球",
    排球: "排球",
    乒乓球: "乒乓球",
    羽毛球: "羽毛球",
    板球: "板球",
    搏击: "搏击",
    全部: "全部",
    其他: "其他",
    icon_alt: "图标",
    loading: "加载中...",
    no_more: "没有更多数据了",
    load_more: "查看更多",
  },
  liveChat: {
    enter_room: "进入聊天室",
    anchor_offline: "主播已下播，不能发送聊天内容",
    room_closed: "聊天室已关闭",
    input_tip: "请输入不超过30个字符的聊天内容...",
    please: "请先",
    login: "登录",
    send: "发送",
    new_msg: "有{num}新消息",
    welcome: "欢迎",
    iknow: "我知道了",
    muted_tip: "您已被禁言，请联系管理员！",
    force_offline: "您已被强制下播，请联系客服！",
    muted: "已被禁言",
    cleared: "聊天信息已被清空",
    room_closed_try: "聊天室已关闭，请稍再试！",
    loading: "聊天数据加载中，请稍后！",
    input_empty: "请输入聊天内容！",
    room_opened: "聊天室已打开",
  },
  liveDetails: {
    resting: "主播休息中…",
    sports_live: "体育直播",
    share: "分享",
    share_tip: "呼唤小伙伴前来围观吧",
    copy: "复制",
    mobile_watch: "手机观看",
    download_app_anytime: "下载APP随时随地",
    free_watch: "免费看赛事直播",
    qr_alt: "二维码",
    people: "人",
    subscribe: "订阅",
    subscribed: "已订阅",
    anchor_offline: "主播已下播",
    recommend_live: "为你推荐直播",
    subscribe_tip: "订阅主播可收到开播提醒",
    icon_alt: "图标",
    live_notice: "直播公告",
    welcome: "欢迎来到{name}的直播间",
    contact_us: "联系我们",
    qq_wechat: "qq/微信",
    push_order: "主播推单",
    push_order_list: "推单列表",
    follow: "人跟单",
    oppose: "人反买",
    combo: "连击",
    give: "赠送",
  },
  liveSettingDialog: {
    title: "直播设置",
    live_title: "直播标题",
    live_category: "直播分类",
    service_select: "客服选择",
    cover_upload: "封面上传",
    cover_tip: "封面建议大小为2MB，不上传封面随机截屏作为封面",
    live_notice: "直播公告",
    relate_title: "关联赛事数据分析",
    just_live: "单纯开播",
    relate_live: "关联比赛数据开播",
    not_started: "未开始",
    in_progress: "比赛中",
    team_logo: "队标",
    contact_title: "联系方式",
    qq_number: "号码",
    qq_placeholder: "请输入您要添加的联系QQ号",
    show_status: "显示状态",
    hide_all: "隐藏全部",
    show_all: "显示全部",
    show_copy: "显示复制按钮",
    close: "关闭",
  },
  personal: {
    account: "个人账号",
    go_live: "我要直播",
    push_order: "我要推单",
    account_setting: "账号设置",
    base_info: "基础资料",
    change_avatar: "修改头像",
    change_password: "修改密码",
    change_skin: "切换皮肤",
    my_social: "我的社交",
    my_follow: "我的关注",
    my_fans: "我的粉丝",
    my_room: "我的房间",
    my_live_room: "我的直播间",
    my_live_record: "我的直播记录",
    diamond: "钻石",
    tip: "提示",
    switch_skin_tip: "是否切换{skin}皮肤？",
    cancel: "取消",
    confirm: "确定",
    unmute_tip: "确认是否解除该用户禁言",
    save: "保存",
    upload_avatar: "上传头像",
    only_support: "(仅支持jpg、jpeg、png)",
    keep: "保存",
    cancel_follow: "取消关注",
    subscribe: "订阅",
    unsubscribe: "取消订阅",
    search: "搜索",
    start_time: "开始日期",
    end_time: "结束日期",
    query_time: "查询时间",
    live_title: "直播标题",
    live_type: "直播类型",
    live_start: "开播时间",
    live_end: "结束时间",
    live_people: "房间人数",
    live_diamond: "钻石",
    live: "一般直播",
    current_password: "当前密码",
    new_password: "新密码",
    confirm_password: "确认密码",
    please_input: "请输入",
    please_input_nickname: "请输入昵称",
    please_input_signature: "请输入签名",
    please_input_birthday: "请输入生日",
    please_input_password: "请输入当前密码",
    please_input_new_password: "请输入新密码",
    please_input_confirm_password: "请输入确认密码",
    please_input_avatar: "请上传需要修改的头像图片",
    please_input_sign: "请输入签名",
    please_input_room: "请输入房间号",
    please_input_query: "请输入查询内容",
    gender_secret: "保密",
    gender_male: "男",
    gender_female: "女",
    nickname: "昵称",
    gender: "性别",
    signature: "签名",
    birthday: "生日",
    save_success: "保存成功",
    save_fail: "保存失败",
    upload_success: "头像上传成功",
    upload_fail: "头像上传失败，请重新上传",
    password_success: "修改密码成功",
    password_fail: "密码为6-20位字母数字组合！",
    password_not_match: "新密码与确认密码不一致，请重新输入",
    empty: "暂无数据",
    unmute: "解禁",
    status: "状态",
    operation: "操作",
    anchor_name: "主播姓名",
    processed_user: "被处理人",
  },
  pushOrder: {
    list: "推单列表",
    add: "推单新增",
    id: "推送ID",
    category: "推单类型",
    select_category: "请选择推单类型",
    status: "状态",
    select_status: "请选择推单状态",
    desc: "推单描述",
    input_desc: "请输入推单描述",
    buy: "跟单",
    oppose: "反买",
    operate: "操作",
    edit: "编辑",
    delete: "删除",
    confirm_delete: "您确定删除这条数据吗？",
    reset: "重置",
    search: "搜索",
    searching: "搜索中",
    submit: "立即提交",
    submitting: "提交中",
  },
  subscription: {
    living_now: "正在直播中",
    not_live: "暂未开播",
    please_login: "请先登录！",
    login: "登录",
    no_subscribe_live: "暂无订阅直播，快去订阅吧！",
    no_subscribe_anchor: "暂无订阅主播，快去订阅吧！",
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh.js